import "client-only";

type T_BuildAuthUrlOptions = {
  redirect?: string;
  search?: string;
  origin?: string;
};

export const buildAuthUrl = (options: T_BuildAuthUrlOptions = {}): string => {
  const search = options.search ?? window.location.search;
  const origin = options.origin ?? window.location.origin;

  const params = new URLSearchParams(search);
  const source = params.get("utm_source");
  const redirectPath = options.redirect ?? params.get("redirect") ?? undefined;

  const url = new URL("/api/auth/sign-in", origin);

  if (source) url.searchParams.set("source", source);
  if (redirectPath) url.searchParams.set("redirect", redirectPath);

  return url.toString().replace(window.location.origin, "");
};
